import Mercado from '../../../images/MercadoLibre.png';
import Amazon from '../../../images/Amazon.png';
import Walmart from '../../../images/Walmart.png';
import './Customers.scss';

export default function Customers() {
	return (
		<section className='customers fondoCover mb-5'>
			<div className='container'>
				<div className='title-customers text-center pt-3'>
					<p className='display-3 fw-bold m-0 text-white'>Nuestros Clientes</p>
					<p className='text-white'>
						Agradecemos la confianza de nuestros clientes y su preferencia por la excelencia.
					</p>
				</div>
				<div className='row pb-3'>
					<div className='col-12 col-lg-4'>
						<img src={Mercado} alt='Mercado Libre' className='img-fluid' />
					</div>
					<div className='col-12 col-lg-4'>
						<img src={Amazon} alt='Mercado Libre' className='img-fluid' />
					</div>
					<div className='col-12 col-lg-4'>
						<img src={Walmart} alt='Mercado Libre' className='img-fluid' />
					</div>
				</div>
			</div>
		</section>
	);
}
